import React from 'react';
import PropTypes from 'prop-types';
import WithClickTracking from '../../components/WithClickTracking';
import Article from './Article';
import MoreButton from '../../components/MoreButton';

class ArticleSearchResultsContainer extends React.Component {
    render() {
        const { results, onResultClick } = this.props;
   
        return (

                <div className="article-search article-search__item-wrapper row">
                    {results.map((result, i) => {
                        return (
                            <div key={i} className="col-lg-4 col-6 article-search__item neo-center-preview__wrapper mb-4">
                                <ArticleWithClickTracking {...result} onResultClick={onResultClick} />
                            </div>                            
                        );
                    })
                    }
                </div>
            
        );
    }
}

const ArticleWithClickTracking = WithClickTracking(Article);

ArticleSearchResultsContainer.propType = {
    results: PropTypes.arrayOf(
        PropTypes.shape({
            Title: PropTypes.string,
            Link: PropTypes.string,
            Description: PropTypes.string
        })
    )
};

export default ArticleSearchResultsContainer;